import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { BookOpen } from "lucide-react";
import { useSite } from "@/context/SiteContext";
import { useMeta } from "@/lib/useMeta";
import { api, media } from "@/lib/api";
import { Rich } from "@/components/site/Rich";

const esc = (s) => s.replace(/[&<>"]/g, (ch) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[ch]));

export default function HotelPage() {
  const { slug } = useParams();
  const { content } = useSite();
  const [hotel, setHotel] = useState(null);
  const [missing, setMissing] = useState(false);
  useMeta(hotel ? "hotel" : null, { hotel: hotel?.name, city: hotel?.city });

  useEffect(() => {
    setHotel(null);
    setMissing(false);
    api.get(`/hotels/${slug}`).then((r) => setHotel(r.data)).catch(() => setMissing(true));
  }, [slug]);

  if (missing) return <div className="max-w-3xl mx-auto px-4 py-24 text-center" data-testid="hotel-not-found"><h1 className="text-3xl">Hotel not found</h1><Link to="/" className="text-crimson mt-4 inline-block">Back to Home</Link></div>;
  if (!hotel) return <div className="py-24 text-center text-stone-400" data-testid="hotel-loading">Loading…</div>;

  const t = content.hotelpage;
  const html = hotel.content?.replace(/<[^>]*>/g, "").trim() ? hotel.content : t.placeholder_html.replaceAll("{hotel}", esc(hotel.name)).replaceAll("{city}", esc(hotel.city));

  return (
    <div data-testid="hotel-page">
      <section className="bg-ivory-alt border-b border-stone-200">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 py-6 sm:py-8 text-center">
          <span className="block h-[2px] w-10 bg-brass mx-auto mb-3" />
          <h1 className="text-2xl sm:text-3xl text-charcoal break-words" data-testid="hotel-name">{hotel.name}</h1>
        </div>
      </section>
      <section className="max-w-5xl mx-auto px-4 sm:px-6 py-12 sm:py-16">
        {hotel.image && <img src={media(hotel.image)} alt={hotel.name} className="block max-w-full h-auto mx-auto shadow-lg mb-10" style={{ width: `${hotel.image_width || 100}%` }} data-testid="hotel-image" />}
        <Rich html={html} className="text-stone-700 leading-relaxed text-base" testid="hotel-content" />
        <Link to="/digital-edition" className="mt-10 inline-flex items-center gap-2 bg-crimson hover:bg-crimson-hover text-white font-bold text-sm rounded-full px-6 py-3 transition-colors" data-testid="hotel-digital-edition-btn">
          <BookOpen className="w-4 h-4" />{t.button_text}
        </Link>
      </section>
    </div>
  );
}
